import {Pipe, PipeTransform} from '@angular/core';

import {ApplicationSettingsService} from '@app/views/admin/application-settings/application-settings.service';

@Pipe({
    name: 'ngcEntityName',
    pure: false
})
export class EntityNamePipe implements PipeTransform {

    transform(inName: string): string {
        return ApplicationSettingsService.getEntityName(inName);
    }
}
